import {
  getLocalStorage,
  Loader,
  pxToRem,
  pxTovW,
  QuantityButton,
  theme,
  useCommonServiceClientContext,
  Slide,
  deserify,
  IStyles,
  getDifficultyLevelString,
  QuantityButtonV2,
  IconWrapper,
} from '@geneo2-web/shared-ui';
import {
  Box,
  Checkbox,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
  BloomLevelEnum,
  DifficultyLevelEnum,
  Question_QuestionEnum,
} from '@protos/content_management/content.db_pb';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useAppSelector } from '../../../../../reduxStore/reduxHooks';
import { useDispatch } from 'react-redux';
import {
  IFASettingsConfig,
  setFASettingsConfig,
} from '../../../reducer/assessmentFlow.slice';
import { useGlobalContext } from '../../../../../app/Context/GlobalContextProvider';

import {
  getAllQuestionTypeTitleAndEnumArray,
  getDifficultyLevelFromString,
  JEE_MARKING_SCHEME_ALLOWED_TYPES,
  markingSchemeOptions,
  OMR_CONDUCTION_MODE_ALLOWED_TYPES,
} from '../../../Common/ReviewAssessment/functions';
import {
  MarkingSchemeEnum,
  ModeOfConductionEnum,
} from '@protos/learning_management/lms.db_pb';
import { useLocation } from 'react-router-dom';
import { useDownloadContext } from '../../../../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../../../../Auth/auth.events';
import { MarkingSchemeTooltip } from 'libs/shared-ui/src/components/composites/MarkingSchemeTooltip';
import {
  setToastInfo,
  setToastInfoV2,
} from 'apps/teacher/src/pages/Home/reducer/homeDashboard.slice';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import {
  BLOOM_LEVEL_ARRAY,
  getMaxNoOfQuestionsLimit,
  getOmrRemainingQuestionSlotsForSection,
  getQuestionCountInOtherSections,
} from '../../../utils/assessment.utils';
import {
  getAvailableCountForQuestionType,
  getUniqueQuestionIdsFromQpgContent,
} from '../../../utils/QPGv2.utils';
import { getQuestionEnumArrayFromQuestionTypes } from '../../../../Homework/ReviewHomework/functions';
import { getModeOfConductionString } from 'apps/teacher/src/utils/functions';
import { AssessmentCreationEnum } from '@protos/learning_management/lms.assessment.teacher.apis_pb';

const styles: IStyles = {
  root: {
    width: { xs: '100%', md: pxTovW(1250), lg: pxTovW(874) },
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
    mt: pxTovW(20),
    marginX: 'auto',
  },
  totalQuestionsAndTime: {
    width: '100%',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: 'center',
    marginY: { xs: pxToRem(20), md: pxTovW(40), lg: pxTovW(20) },
    gap: { xs: pxToRem(20), md: pxTovW(0) },
  },
  noOfQuestions: {
    width: { xs: '50%', md: '100%' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: { xs: pxToRem(10), md: pxTovW(20) },
    // marginBottom: 'auto',
    marginRight: { xs: 'auto', md: 0 },
  },
  markingScheme: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(20) },
    marginBottom: { xs: pxToRem(30), md: pxTovW(30) },
  },
  markingSchemeGridContainer: {
    padding: 0,
    width: '100%',
    gap: { xx: pxToRem(0), md: pxTovW(20) },
    display: 'flex',
    flexDirection: { xs: 'column', lg: 'row' },
  },
  markingSchemeGridItem: {
    display: 'flex',
    height: { xs: '30px', md: '25px' },
    gap: { xs: pxToRem(8), md: pxTovW(10) },
    alignItems: 'center',
    paddingY: pxTovW(10),
  },
  markingSchemeCheckbox: {
    height: { xs: pxToRem(17), md: pxTovW(30), lg: pxTovW(24) },
    padding: { xs: pxToRem(5), md: pxTovW(8), lg: pxTovW(5) },
    width: { xs: pxToRem(17), md: pxTovW(30), lg: pxTovW(24) },
    borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
  },
  bloomLevelContainer: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(20) },
    mb: { xs: pxToRem(10), md: pxTovW(10) },
    // marginY: { xs: pxToRem(20), md: pxTovW(20) },
    marginBottom: { xs: pxToRem(30), md: pxTovW(30) },
  },
  bloomLevelGridItem: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(8), md: pxTovW(10) },
    paddingY: pxTovW(10),
  },
  bloomLevelCheckbox: {
    height: { xs: pxToRem(17), md: pxTovW(30), lg: pxTovW(24) },
    padding: { xs: pxToRem(5), md: pxTovW(8), lg: pxTovW(5) },
    width: { xs: pxToRem(17), md: pxTovW(30), lg: pxTovW(24) },
    borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
  },
  questionTypeContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(20) },
    marginY: { xs: pxToRem(20), md: pxTovW(20) },
  },
  questionTypeGridItem: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(8), md: pxTovW(10) },
    paddingY: pxTovW(10),
  },
  questionTypeCheckbox: {
    height: { xs: pxToRem(17), md: pxTovW(24) },
    padding: { xs: pxToRem(5), md: pxTovW(5) },
    width: { xs: pxToRem(17), md: pxTovW(24) },
    borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
  },
};

interface SliderLevel {
  key: DifficultyLevelEnum;
  value: number;
  label?: string;
}

export const FACreationSettings = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const teacher_id = getLocalStorage('userId');
  const { isIpadOnly } = useGlobalContext();
  const dispatch = useDispatch();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const { LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler } =
    useCommonServiceClientContext();
  const { class_subject_info } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  const { manage_mode_of_conduction } = deserify(
    useAppSelector((state) => state.manageHomework)
  );
  const {
    fa_content,
    fa_selected_section_number,
    fa_selected_chapters,
    fa_settings_config,
  } = deserify(useAppSelector((state) => state.assessment));

  const [loading, setLoading] = useState<'loading' | 'completed'>('completed');
  const [availableConfig, setAvailableConfig] = useState<IFASettingsConfig>({
    overall_difficulty: fa_settings_config?.overall_difficulty || 'Medium',
    no_of_questions: fa_settings_config?.no_of_questions || 0,
    // approximate_time: fa_settings_config?.approximate_time || 0,
    bloom_levels: fa_settings_config?.bloom_levels || [],
    question_types: fa_settings_config?.question_types || [],
  });

  const sliderLevels = [
    {
      key: DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW,
      value: 0,
      label: 'Easy',
    },
    {
      key: DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM,
      value: 50,
      label: 'Medium',
    },
    {
      key: DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH,
      value: 100,
      label: 'Hard',
    },
  ];

  const [sliderValue, setSliderValue] = useState<SliderLevel>({
    key: getDifficultyLevelFromString(
      fa_settings_config?.overall_difficulty || 'Medium'
    ),
    value:
      sliderLevels.find(
        (e) =>
          e.key ===
          getDifficultyLevelFromString(
            fa_settings_config?.overall_difficulty || 'Medium'
          )
      )?.value || 0,
    label: fa_settings_config?.overall_difficulty,
  });

  const filteredBloomLevelArray = BLOOM_LEVEL_ARRAY.filter((bloomLevel) =>
    availableConfig?.bloom_levels?.includes(bloomLevel.typeKey)
  );

  // --------------------------------------------------------------

  const isQuestionTypeAvailableInConfig = (typeKey: Question_QuestionEnum) =>
    getAvailableCountForQuestionType({
      questionType: typeKey,
      noOfQuestionsByTypes: availableConfig?.question_type_count,
    }) > 0;

  // --------------------------------------------------------------

  const getQuestionTypes = () => {
    const allTypes = getAllQuestionTypeTitleAndEnumArray();

    let finalList;
    if (
      fa_content?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      finalList = allTypes.filter(
        (qt) =>
          OMR_CONDUCTION_MODE_ALLOWED_TYPES.includes(qt.typeKey) &&
          isQuestionTypeAvailableInConfig(qt.typeKey)
      );
    } else if (
      fa_settings_config?.marking_scheme ===
      MarkingSchemeEnum.MARKING_SCHEME_JEE
    ) {
      finalList = allTypes.filter(
        (qt) =>
          JEE_MARKING_SCHEME_ALLOWED_TYPES.includes(qt.typeKey) &&
          isQuestionTypeAvailableInConfig(qt.typeKey)
      );
    } else {
      finalList = allTypes.filter((qt) =>
        isQuestionTypeAvailableInConfig(qt.typeKey)
      );
    }

    return finalList;
  };

  const questionTypesList = useMemo(
    () => getQuestionTypes(),
    [fa_settings_config?.marking_scheme, availableConfig?.question_type_count]
  );

  // --------------------------------------------------------------

  const questionsInOtherSections = useMemo(
    () =>
      getQuestionCountInOtherSections({
        multiSubjectSections: fa_content?.multiSubjectSections,
        currentSectionNo: fa_selected_section_number,
      }),
    [fa_content?.multiSubjectSections, fa_selected_section_number]
  );

  // --------------------------------------------------------------

  const maxQuantityFromSelectedTypes = useMemo(() => {
    const selectedTypes = fa_settings_config?.question_types ?? [];
    const typeCount = availableConfig?.question_type_count;
    if (selectedTypes.length === 0 || !typeCount) return 0;
    const totalAvailable = selectedTypes.reduce(
      (sum, questionType) =>
        sum +
        getAvailableCountForQuestionType({
          questionType,
          noOfQuestionsByTypes: typeCount,
        }),
      0
    );
    return getMaxNoOfQuestionsLimit({
      totalAvailableFromTypes: totalAvailable,
      modeOfConduction: fa_content?.assessment?.modeOfConduction,
      questionsInOtherSections,
    });
  }, [
    fa_settings_config?.question_types,
    availableConfig?.question_type_count,
    fa_content?.assessment?.modeOfConduction,
    questionsInOtherSections,
  ]);

  // --------------------------------------------------------------

  const markingSchemeOnChange = async (
    //disabled it is being chosen at the Start of flow
    marking: (typeof markingSchemeOptions)[number],
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isJEE = marking.type === MarkingSchemeEnum.MARKING_SCHEME_JEE;
    const isOMR =
      fa_content?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR;
    const typeCount = availableConfig?.question_type_count;
    const questionTypes =
      typeCount && isOMR
        ? OMR_CONDUCTION_MODE_ALLOWED_TYPES.filter(
            (questionType) =>
              getAvailableCountForQuestionType({
                questionType,
                noOfQuestionsByTypes: typeCount,
              }) > 0
          )
        : typeCount && isJEE
        ? JEE_MARKING_SCHEME_ALLOWED_TYPES.filter(
            (questionType) =>
              getAvailableCountForQuestionType({
                questionType,
                noOfQuestionsByTypes: typeCount,
              }) > 0
          )
        : typeCount
        ? getQuestionEnumArrayFromQuestionTypes(typeCount)
        : [];
    dispatch(
      setFASettingsConfig({
        ...fa_settings_config,
        marking_scheme: marking.type,
        question_types: questionTypes,
      })
    );

    await interactionEvent({
      url: 'Teacher_formative_assessment_create',
      context: 'Marking_Scheme',
      name: `${marking.title}_${e.target.checked ? 'SELECT' : 'DESELECT'}`
        .toUpperCase()
        .replace(/\s+/g, '_'),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // --------------------------------------------------------------

  const fetchModuleQuestionStatsInitial = async (props: {
    updatedBlooms?: BloomLevelEnum[];
  }) => {
    const { updatedBlooms } = props;
    const moduleIds =
      fa_selected_chapters?.chapters
        .flatMap((chapter) => [
          chapter.chapterId,
          ...chapter.topics.map((topic) => topic.topicId),
        ])
        ?.sort((a, b) => a - b) || [];
    if (!moduleIds || moduleIds.length === 0) {
      return;
    }

    const currentSection = fa_content?.multiSubjectSections?.find(
      (section) => section.sectionNo === fa_selected_section_number
    );

    const isJEE =
      currentSection?.markingSchemeType ===
      MarkingSchemeEnum.MARKING_SCHEME_JEE;

    const allBloomLevels = BLOOM_LEVEL_ARRAY.map(({ typeKey }) => typeKey);

    try {
      setLoading('loading');

      const response =
        await LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler.getModuleQuestionStats(
          {
            personId: BigInt(teacher_id),
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            moduleIds: moduleIds,
            qIdsToBeIgnored: getUniqueQuestionIdsFromQpgContent({
              qpgContent: fa_content,
              sectionNumbersToIgnore:
                fa_selected_section_number !== undefined
                  ? [fa_selected_section_number]
                  : [],
            }),
            bloomLevels: isJEE ? undefined : updatedBlooms || allBloomLevels,
            modeOfConduction: fa_content?.assessment?.modeOfConduction,
            assessmentCreationType:
              AssessmentCreationEnum.ASSESSMENT_CREATION_FORMATIVE,
          }
        );
      if (response.data) {
        const data = response.data;
        setAvailableConfig((prev) => ({
          ...prev,
          no_of_questions: data.noOfQuestions,
          overall_difficulty: getDifficultyLevelString(data.avgDifficultyLevel),
          question_type_marks: data.questionTypeAndMarks,
          question_type_count: data.questionTypes,
          bloom_levels: isJEE
            ? undefined
            : updatedBlooms
            ? prev.bloom_levels
            : data.bloomLevels,
        }));

        if (!fa_settings_config) {
          const omrSectionCap =
            fa_content?.assessment?.modeOfConduction ===
            ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
              ? getOmrRemainingQuestionSlotsForSection({
                  multiSubjectSections: fa_content?.multiSubjectSections,
                  currentSectionNo: fa_selected_section_number,
                })
              : undefined;
          dispatch(
            setFASettingsConfig({
              ...(fa_settings_config ?? {}),
              no_of_questions: Math.min(
                10,
                data.noOfQuestions,
                ...(omrSectionCap !== undefined ? [omrSectionCap] : [])
              ),
              // approximate_time: response.data.approximateTime,
              overall_difficulty: getDifficultyLevelString(
                data.avgDifficultyLevel
              ),
              // marking_scheme: MarkingSchemeEnum.MARKING_SCHEME_GENEO,
              marking_scheme: currentSection?.markingSchemeType,
              bloom_levels: isJEE ? undefined : data.bloomLevels,
              question_type_marks: data.questionTypeAndMarks,
              question_type_count: data.questionTypes,
              question_types:
                fa_content?.assessment?.modeOfConduction ===
                ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
                  ? OMR_CONDUCTION_MODE_ALLOWED_TYPES
                  : isJEE
                  ? JEE_MARKING_SCHEME_ALLOWED_TYPES
                  : data.questionTypes
                  ? getQuestionEnumArrayFromQuestionTypes(data.questionTypes)
                  : [],
            })
          );
        } else {
          const bloomLevelsToPersist =
            updatedBlooms ?? fa_settings_config?.bloom_levels;
          const omrSectionCap =
            fa_content?.assessment?.modeOfConduction ===
            ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
              ? getOmrRemainingQuestionSlotsForSection({
                  multiSubjectSections: fa_content?.multiSubjectSections,
                  currentSectionNo: fa_selected_section_number,
                })
              : undefined;
          dispatch(
            setFASettingsConfig({
              ...fa_settings_config,
              no_of_questions: Math.min(
                fa_settings_config?.no_of_questions ?? 10,
                data.noOfQuestions,
                ...(omrSectionCap !== undefined ? [omrSectionCap] : [])
              ),
              bloom_levels: isJEE ? undefined : bloomLevelsToPersist,
            })
          );
        }
      } else {
        dispatch(
          setToastInfo({
            label: 'Error while fetching question stats',
            variant: 'error',
            open: true,
          })
        );
      }
    } catch (err) {
      console.log(err);
      dispatch(
        setToastInfoV2({
          label: 'Error while fetching question stats',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setLoading('completed');
    }
  };

  // --------------------------------------------------------------

  useEffect(() => {
    if (questionTypesList.length !== 0) return;

    dispatch(
      setToastInfo({
        label: 'No question types available',
        variant: 'error',
        open: true,
      })
    );

    // Keep the parent step CTA disabled when there are no available types.
    dispatch(
      setFASettingsConfig({
        ...(fa_settings_config ?? {}),
        no_of_questions: 0,
        question_types: [],
      })
    );
  }, [questionTypesList.length]);

  // --------------------------------------------------------------

  useEffect(() => {
    /*
    Keeps `no_of_questions` within what's currently available for the selected question types.
    Only clamp when we have a valid max; when max is 0 it may mean "not yet loaded"
    and would overwrite a valid no_of_questions from the fetch (race condition).
    */
    const currentNo = fa_settings_config?.no_of_questions ?? 0;
    if (
      maxQuantityFromSelectedTypes > 0 &&
      currentNo > maxQuantityFromSelectedTypes
    ) {
      dispatch(
        setFASettingsConfig({
          ...fa_settings_config,
          no_of_questions: maxQuantityFromSelectedTypes,
        })
      );
    }
  }, [maxQuantityFromSelectedTypes, fa_settings_config?.no_of_questions]);

  // --------------------------------------------------------------

  useEffect(() => {
    fetchModuleQuestionStatsInitial({});
  }, []);

  // --------------------------------------------------------------

  // if (loading === 'loading') return <Loader />;

  return (
    <Box sx={styles.root}>
      {loading === 'loading' && (
        <Loader
          sx={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh' }}
        />
      )}

      <Box sx={{ marginY: { xs: pxToRem(23), md: pxTovW(41) } }}>
        <Typography variant="h2" textAlign="center">
          <span style={{ color: '#007CDC' }}>Step 2: </span>Now Set Your
          Configuration Settings
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: pxToRem(10), md: pxTovW(20) },
          mb: { xs: pxToRem(20), md: pxTovW(40) },
        }}
      >
        <Typography variant="h3" fontWeight="bold">
          Conduction Via
        </Typography>
        <Box sx={{ display: 'flex', gap: pxTovW(10), alignItems: 'center' }}>
          <IconWrapper
            name={
              fa_content?.assessment?.modeOfConduction ===
              ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
                ? 'clicker_icon'
                : fa_content?.assessment?.modeOfConduction ===
                  ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
                ? 'omr'
                : 'mobile-app'
            }
            type="png"
            parentFolder="icons"
            customSx={{
              width: { xs: pxToRem(20), md: pxTovW(35) },
              height: { xs: pxToRem(40), md: pxTovW(42) },
            }}
          />
          <Typography variant="h4" fontWeight="bold">
            {getModeOfConductionString(
              fa_content?.assessment?.modeOfConduction
            )}
          </Typography>
        </Box>
      </Box>

      {/* //& Total Questions and Approximate Time */}
      <Box sx={styles.totalQuestionsAndTime}>
        <Box sx={styles.noOfQuestions}>
          <Typography variant="h3" fontWeight="bold" marginRight={'auto'}>
            No. of Questions
          </Typography>
          {/* <QuantityButton
            withBorder
            quantity={fa_settings_config?.no_of_questions || 0}
            maxQuantity={maxQuantityFromSelectedTypes}
            disabled={maxQuantityFromSelectedTypes === 0}
            incrementClickHandler={async () => {
              if (
                (fa_settings_config?.no_of_questions || 0) <
                maxQuantityFromSelectedTypes
              ) {
                dispatch(
                  setFASettingsConfig({
                    ...fa_settings_config,
                    no_of_questions:
                      (fa_settings_config?.no_of_questions || 0) + 1,
                  })
                );
              }
              // await interactionEvent({
              //   url: 'Teacher_formative_assessment_create',
              //   context: 'Number_of_questions',
              //   name: 'ADD',
              //   pathSegments: pathSegments,
              //   isOffline: isOffline,
              // });
            }}
            decrementClickHandler={async () => {
              if (
                fa_settings_config?.no_of_questions &&
                fa_settings_config?.no_of_questions > 0
              ) {
                dispatch(
                  setFASettingsConfig({
                    ...fa_settings_config,
                    no_of_questions: fa_settings_config?.no_of_questions - 1,
                  })
                );
              }
              // await interactionEvent({
              //   url: 'Teacher_formative_assessment_create',
              //   context: 'Number_of_questions',
              //   name: 'REMOVE',
              //   pathSegments: pathSegments,
              //   isOffline: isOffline,
              // });
            }}
          /> */}

          <QuantityButtonV2
            value={fa_settings_config?.no_of_questions || 0}
            max={maxQuantityFromSelectedTypes}
            disabled={maxQuantityFromSelectedTypes === 0}
            onChange={async (nextValue: number) => {
              dispatch(
                setFASettingsConfig({
                  ...fa_settings_config,
                  no_of_questions: nextValue,
                })
              );
            }}
            onIncrement={async () => {
              dispatch(
                setFASettingsConfig({
                  ...fa_settings_config,
                  no_of_questions:
                    (fa_settings_config?.no_of_questions || 0) + 1,
                })
              );
            }}
            onDecrement={async () => {
              dispatch(
                setFASettingsConfig({
                  ...fa_settings_config,
                  no_of_questions:
                    (fa_settings_config?.no_of_questions || 0) - 1,
                })
              );
            }}
          />
        </Box>

        {/* {!isMobile && (
          <Divider
            orientation="vertical"
            sx={{
              width: '1px',
              height: '100%',
              marginRight: pxToRem(50),
              borderStyle: 'dashed',
            }}
          />
        )} */}

        {/* <ApproximateTime
          approximateTime={fa_settings_config?.approximate_time || 0}
          questionCount={fa_settings_config?.no_of_questions || 0}
          difficulty={fa_settings_config?.overall_difficulty || 'Medium'}
          setApproximateTime={async (time: number) => {
            dispatch(
              setFASettingsConfig({
                ...fa_settings_config,
                approximate_time: time,
              })
            );
            // await interactionEvent({
            //   url: 'Teacher_formative_assessment_create',
            //   context: 'Approximate_time',
            //   name: 'TIME_SELECTION',
            //   pathSegments: pathSegments,
            //   isOffline: isOffline,
            // });
          }}
        /> */}
      </Box>

      <Divider
        sx={{
          width: '100%',
          height: '1px',
          marginY: { xs: pxToRem(20), md: pxTovW(30) },
        }}
      />

      {/* //& Overall Difficulty */}
      <Box sx={{ width: '100%', marginY: { xs: pxToRem(20), md: 0 } }}>
        <Slide
          sliderLevels={sliderLevels}
          titleText="Overall Difficulty"
          isDisable={false}
          minLevel={0}
          maxLevel={100}
          step={50}
          slideValue={sliderValue}
          SliderOnChangeValue={async (val: SliderLevel) => {
            setSliderValue(val);
            dispatch(
              setFASettingsConfig({
                ...fa_settings_config,
                overall_difficulty: val.label,
              })
            );

            // await interactionEvent({
            //   url: 'Teacher_formative_assessment_create',
            //   context: 'Overall_difficulty',
            //   name:
            //     val.value === DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW
            //       ? 'LOW'
            //       : val.value === DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM
            //       ? 'MEDIUM'
            //       : 'HIGH',
            //   pathSegments: pathSegments,
            //   isOffline: isOffline,
            // });
          }}
        />
      </Box>

      {/* //& Marking Scheme */}
      {/*  Temporarily hiding marking scheme for clicker assessments */}
      {fa_content?.assessment?.modeOfConduction !==
        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER && (
        <>
          <Divider
            sx={{
              borderColor: '1px solid red',
              width: '100%',
              height: '1px',
              marginY: { xs: pxToRem(20), md: pxTovW(30) },
            }}
          />

          <Box sx={styles.markingScheme}>
            <Typography variant="h3" fontWeight="bold">
              Marking Scheme
            </Typography>
            <Grid
              container
              spacing={2}
              columns={16}
              rowGap={5}
              sx={styles.markingSchemeGridContainer}
            >
              {markingSchemeOptions.map((marking, index) => (
                <Grid
                  item
                  xs={6}
                  md={4}
                  key={index}
                  sx={styles.markingSchemeGridItem}
                >
                  <Checkbox
                    disabled // it is being chosen at the Start of flow
                    checked={
                      fa_settings_config?.marking_scheme === marking.type
                    }
                    onChange={(ev) => markingSchemeOnChange(marking, ev)}
                    sx={styles.markingSchemeCheckbox}
                    color="primary"
                  />
                  <Typography
                    variant={isIpadOnly ? 'h3' : 'h4'}
                    sx={{
                      width: 'max-content',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {marking.title}
                    <span>
                      {marking.type ===
                        MarkingSchemeEnum.MARKING_SCHEME_JEE && (
                        <MarkingSchemeTooltip />
                      )}
                    </span>
                    <span style={{ marginLeft: pxTovW(10) }}>
                      {marking.type ===
                        MarkingSchemeEnum.MARKING_SCHEME_CUSTOM &&
                      fa_content?.questionsSequenceInfo?.marksPerQuestion ? (
                        <Typography variant="smallText" color="blue">
                          {fa_content?.questionsSequenceInfo?.marksPerQuestion}{' '}
                          marks per question
                        </Typography>
                      ) : null}
                    </span>
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Box>
        </>
      )}

      {/* //& Bloom Level */}
      {fa_settings_config?.marking_scheme !==
        MarkingSchemeEnum.MARKING_SCHEME_JEE && (
        <>
          <Divider
            sx={{
              borderColor: '1px solid red',
              width: '100%',
              height: '1px',
              marginY: { xs: pxToRem(20), md: pxTovW(30) },
              // marginTop: pxTovW(30),
            }}
          />

          <Box sx={styles.bloomLevelContainer}>
            <Typography variant="h3" fontWeight="bold">
              Bloom Level
            </Typography>
            <Grid
              container
              spacing={2}
              columns={16}
              rowGap={5}
              sx={{ padding: 0, width: '100%' }}
            >
              {filteredBloomLevelArray.map((bloomLevel, index) => (
                <Grid
                  item
                  xs={6}
                  md={4}
                  key={index}
                  sx={styles.bloomLevelGridItem}
                >
                  <Checkbox
                    checked={
                      !!fa_settings_config?.bloom_levels?.find(
                        (e) => e === bloomLevel.typeKey
                      )
                    }
                    onChange={async (ev) => {
                      let updatedBlooms;
                      if (ev.target.checked) {
                        updatedBlooms = [
                          ...(fa_settings_config?.bloom_levels || []),
                          bloomLevel.typeKey,
                        ];
                        dispatch(
                          setFASettingsConfig({
                            ...fa_settings_config,
                            bloom_levels: updatedBlooms,
                          })
                        );
                      } else {
                        updatedBlooms = (
                          fa_settings_config?.bloom_levels || []
                        ).filter((level) => level !== bloomLevel.typeKey);

                        dispatch(
                          setFASettingsConfig({
                            ...fa_settings_config,
                            bloom_levels: updatedBlooms,
                          })
                        );
                      }

                      fetchModuleQuestionStatsInitial({ updatedBlooms });
                      await interactionEvent({
                        url: 'Teacher_formative_assessment_create',
                        context: 'Bloom_level',
                        name: `${bloomLevel.title}_${
                          ev.target.checked ? 'SELECT' : 'DESELECT'
                        }`
                          .toUpperCase()
                          .replace(/\s+/g, '_'),
                        pathSegments: pathSegments,
                        isOffline: isOffline,
                      });
                    }}
                    sx={styles.bloomLevelCheckbox}
                    color="primary"
                  />
                  <Typography
                    variant={isIpadOnly ? 'h3' : 'h4'}
                    sx={{
                      width: 'max-content',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {bloomLevel.title}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Box>
        </>
      )}

      <Divider
        sx={{
          borderColor: '1px solid red',
          width: '100%',
          height: '1px',
          marginY: { xs: pxToRem(20), md: pxTovW(30) },
        }}
      />

      {/* //& Question Type */}
      <Box sx={styles.questionTypeContainer}>
        <Typography variant="h3" fontWeight="bold">
          Question Type
        </Typography>

        {questionTypesList.length === 0 && (
          <Typography variant="h3" fontWeight="regular">
            No questions available.
          </Typography>
        )}

        <Grid
          container
          spacing={2}
          rowGap={5}
          columns={16}
          sx={{ padding: 0, width: '100%' }}
        >
          {/* {filteredQuestionTypeArray.map((questionType, index) => ( */}
          {questionTypesList.map((questionType, index) => (
            <Grid
              item
              xs={6}
              md={4}
              key={index}
              sx={styles.questionTypeGridItem}
            >
              <Checkbox
                // might have to disable based on intial values of question types
                checked={
                  !!fa_settings_config?.question_types?.find(
                    (e) => e === questionType.typeKey
                  )
                }
                onChange={async (e) => {
                  if (e.target.checked) {
                    // setAssessmentConfig({
                    //   ...assessmentConfig,
                    //   QuestionTypes: [
                    //     ...(assessmentConfig.QuestionTypes || []),
                    //     questionType.typeKey,
                    //   ],
                    // });
                    dispatch(
                      setFASettingsConfig({
                        ...fa_settings_config,
                        question_types: [
                          ...(fa_settings_config?.question_types || []),
                          questionType.typeKey,
                        ],
                      })
                    );
                  } else {
                    // setAssessmentConfig({
                    //   ...assessmentConfig,
                    //   QuestionTypes: (
                    //     assessmentConfig.QuestionTypes || []
                    //   ).filter((type) => type !== questionType.typeKey),
                    // });
                    dispatch(
                      setFASettingsConfig({
                        ...fa_settings_config,
                        question_types: (
                          fa_settings_config?.question_types || []
                        ).filter((type) => type !== questionType.typeKey),
                      })
                    );
                  }
                  await interactionEvent({
                    url: 'Teacher_formative_assessment_create',
                    context: 'Question_type',
                    name: `${questionType.title}_${
                      e.target.checked ? 'SELECT' : 'DESELECT'
                    }`
                      .toUpperCase()
                      .replace(/\s+/g, '_')
                      .replace(/[/]/g, '_'),
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }}
                sx={styles.questionTypeCheckbox}
                color="primary"
              />
              <Typography
                variant={isIpadOnly ? 'h3' : 'h4'}
                sx={{
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {questionType.title}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

// =====================================================

interface IApproximateTimeProps {
  approximateTime: number;
  questionCount: number;
  difficulty: string;
  setApproximateTime: (time: number) => void;
}

export const ApproximateTime = (props: IApproximateTimeProps) => {
  const dispatch = useDispatch();
  const { fa_settings_config } = deserify(
    useAppSelector((state) => state.assessment)
  );
  const { approximateTime, questionCount, difficulty, setApproximateTime } =
    props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const difficultyTimes = {
    Easy: [0.5, 0.75, 1], // in minutes
    Medium: [1, 1.75, 2.5],
    Hard: [2.5, 3.25, 4],
  };

  const times = difficultyTimes[difficulty as keyof typeof difficultyTimes] || [
    1, 1.75, 2.5,
  ];

  const [selectedTime, setSelectedTime] = useState(times[1]);
  const configRef = useRef(fa_settings_config);
  configRef.current = fa_settings_config;

  if (!times) {
    throw new Error(
      "Invalid difficulty level. Choose 'easy', 'medium', or 'hard'."
    );
  }

  // --------------------------------------------------------------

  useEffect(() => {
    setSelectedTime(times[1]);
  }, [difficulty]);

  // --------------------------------------------------------------

  useEffect(() => {
    const timeForSelectedDifficulty =
      fa_settings_config?.overall_difficulty === 'Easy'
        ? difficultyTimes.Easy[1]
        : fa_settings_config?.overall_difficulty === 'Medium'
        ? difficultyTimes.Medium[1]
        : difficultyTimes.Hard[1];

    dispatch(
      setFASettingsConfig({
        ...fa_settings_config,
        // approximate_time: Math.round(questionCount * timeForSelectedDifficulty),
      })
    );
  }, [fa_settings_config?.overall_difficulty]);

  // --------------------------------------------------------------

  useEffect(() => {
    dispatch(
      setFASettingsConfig({
        ...fa_settings_config,
        // approximate_time: Math.round(questionCount * selectedTime),
      })
    );
  }, [fa_settings_config?.no_of_questions]);

  // --------------------------------------------------------------

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: { xs: pxToRem(10), md: pxTovW(15) },
        marginTop: { md: pxTovW(20), lg: 0 },
      }}
    >
      <Typography variant="h3" fontWeight="bold">
        Approximate Time
      </Typography>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          gap: { md: pxTovW(33) },
        }}
      >
        {times.map((time, index) => (
          <Box
            sx={{
              background: selectedTime === time ? '#007CDC' : '#F5FAFF',
              display: 'flex',
              height: { xs: pxToRem(50), md: pxTovW(75) },
              borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
              boxSizing: 'border-box',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              border: selectedTime === time ? 'none' : '2px solid #A8D3FC',
              padding: {
                xs: `${pxToRem(17)} ${pxToRem(15)}`,
                md: `${pxTovW(30)} ${pxTovW(25)}`,
                lg: `${pxTovW(28)} ${pxTovW(25)}`,
              },
              gap: { xs: pxToRem(5), md: pxTovW(5) },
            }}
            onClick={() => {
              setSelectedTime(time);
              setApproximateTime(Math.round(questionCount * time));
              dispatch(
                setFASettingsConfig({
                  ...fa_settings_config,
                  // approximate_time: Math.round(questionCount * time),
                })
              );
            }}
          >
            <AccessTimeIcon
              sx={{
                height: { xs: pxToRem(14), md: pxTovW(18) },
                width: { xs: pxToRem(14), md: pxTovW(18) },
                color: selectedTime === time ? '#FFFFFF' : 'black',
              }}
            />
            <Typography
              variant="h5"
              sx={{
                color: selectedTime === time ? '#FFFFFF' : 'black',
              }}
            >
              <Typography
                variant={isMobile ? 'h4' : 'h3'}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px', // space between number and "mins"
                  color: selectedTime === time ? '#FFFFFF' : 'black',
                }}
              >
                {Math.round(questionCount * time)}
                <Box component="span" sx={{ fontSize: 'inherit' }}>
                  mins
                </Box>
              </Typography>
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
